import React, {Component} from 'react';
import ReactTooltip from 'react-tooltip'

var CenteredDiv = React.createClass({
    render: function () {
        var centerDivClasses = this.props.className + ' center-block';
        if (this.props.isBorder != null) 
            centerDivClasses += ' border';
        
        var divWidth = this.props.width
            ? this.props.width
            : '';
        const centerDivStyle = {
            width: divWidth
        };
        return (
            <div className={centerDivClasses} style={centerDivStyle}>{this.props.children}</div>
        )
    }
});

var Load = React.createClass({
    getInitialState: function () {
        return this.state = {
            visible: false
        };
    },
    Show: function () {
        this.setState({visible: true});
    },
    Hide: function () {
        this.setState({visible: false});
    },
    render: function () {
        if (!this.state.visible) {
            return null;
        }
        return (
            <div className="overlay loading">
                <script type="text/javascript" src="javascript/Loading.js"/>
                <div className="loading-gif align-middle"></div>
            </div>
        )
    }
})

var Warning = React.createClass({
    getInitialState: function () {
        return this.state = {
            visible: false,
            tooltipText: ''
        };
    },
    Show: function (tooltipText) {
        this.setState({visible: true, tooltipText: tooltipText});
    },
    Hide: function () {
        this.setState({visible: false});
    },
    render: function () {
        if (!this.state.visible) {
            return null;
        }
        return (
            <div className="Warning" data-tip={this.state.tooltipText}><ReactTooltip type='error' place="right" /></div>
        )
    }
});


var LabelWithArrow = React.createClass({
    render() {
        var classes = "LabelWithArrow " + this.props.className; 
        return (
            <label className={classes} onClick={this.props.onClick}>{this.props.Label}<span className='glyphicon glyphicon-triangle-bottom' aria-hidden="true"/></label>
        )
    }
});

module.exports = {
    CenteredDiv: CenteredDiv,
    Load: Load,
    Warning: Warning,
    LabelWithArrow: LabelWithArrow
}


// WEBPACK FOOTER //
// ./modules/common/basic.jsx